import React from "react";

const Footer = () => {
    return (
        <section className="prom__layout--footer">
            <span>{new Date().getFullYear()} &copy; PROM-OPECS</span>
        </section>
    )
};

export default Footer
